import { render, staticRenderFns } from "./Hosting.vue?vue&type=template&id=bcac089e&scoped=true&"
import script from "./Hosting.vue?vue&type=script&lang=js&"
export * from "./Hosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcac089e",
  null
  
)

export default component.exports